import BasePlugin from '@uppy/core/lib/BasePlugin'
import { blobToBase64 } from 'Logic/base64.js'

/**
 * Adds HTML content to the editor at the current caret position,
 * or at the end if the caret position is not valid.
 * @param {import('../EditableTextArea/types.d.ts').Editor} editor
 * @param {string} html
 */
function insertAtCaretOrEnd(editor, html) {
  try {
    editor.insertContent(html)
  } catch (e) {
    // move caret to end and insert
    let body = editor.getBody()
    editor.selection.select(body, true)
    editor.selection.collapse(false)

    editor.insertContent(html)
  }
}

export default class EditorFilesUploader extends BasePlugin {
  constructor(uppy, opts) {
    super(uppy, opts)
    this.type = 'uploader'
    this.id = this.opts.id || 'EditorFilesUploader'
    this.title = 'EditorFilesUploader'

    this.handleUpload = this.handleUpload.bind(this)
  }

  async handleUpload(fileIDs) {
    for (let fileId of fileIDs) {
      let imgBase64 = await blobToBase64(this.uppy.getFile(fileId).data)
      insertAtCaretOrEnd(
        this.opts.editor,
        `<img src="${imgBase64}" style="width:600px;" />`
      )
    }
  }

  install() {
    this.uppy.addUploader(this.handleUpload)
  }

  uninstall() {
    this.uppy.removeUploader(this.handleUpload)
  }
}

EditorFilesUploader.pluginName = 'EditorFilesUploader'
